import { createMiddlewareAction } from './createMiddlewareAction'
import { endpoints } from '../api/endpoints'
import { hospitalsTypes } from '../constantes/actionTypes'

export const hospitalsActions = {
  getAllHospitals: (zoneId) =>
    createMiddlewareAction({
      successType: hospitalsTypes.GET_ALL_HOSPITALS_SUCCESS,
      failureType: hospitalsTypes.GET_ALL__HOSPITALS_FAILURE,
      method: 'GET',
      endpoint: endpoints.GET_ALL_HOSPITALS,
    }),
  getAllHospitalsByZoneCityPaged: (zoneId, city, page) =>
    createMiddlewareAction({
      successType: hospitalsTypes.GET_ALL_HOSPITALS_BY_ZONE_CITY_PAGED_SUCCESS,
      failureType: hospitalsTypes.GET_ALL_HOSPITALS_BY_ZONE_CITY_PAGED_FAILURE,
      method: 'GET',
      endpoint: endpoints.GET_ALL_HOSPITALS_BY_ZONE_CITY_PAGED(
        zoneId,
        city,
        page,
      ),
    }),
  newHospital: (hospital) =>
    createMiddlewareAction({
      successType: hospitalsTypes.NEW_HOSPITAL_SUCCESS,
      failureType: hospitalsTypes.NEW_HOSPITAL_FAILURE,
      method: 'POST',
      endpoint: endpoints.NEW_HOSPITALS,
      body: hospital,
    }),
  updateHospital: (hospital) =>
    createMiddlewareAction({
      successType: hospitalsTypes.UPDATE_HOSPITAL_SUCCESS,
      failureType: hospitalsTypes.UPDATE_HOSPITAL_FAILURE,
      method: 'PUT',
      endpoint: endpoints.UPDATE_HOSPITALS,
      body: hospital,
    }),
  deleteHospital: (idHospital) =>
    createMiddlewareAction({
      successType: hospitalsTypes.DELETE_HOSPITAL_SUCCESS,
      failureType: hospitalsTypes.DELETE_HOSPITAL_FAILURE,
      method: 'DELETE',
      endpoint: endpoints.DELETE_HOSPITALS(idHospital),
    }),
  clearHospitalsList: () => ({
    type: hospitalsTypes.CLEAR_HOSPITALS_LIST,
  }),
  getAllCommunities: () => createMiddlewareAction({
    successType: hospitalsTypes.GET_ALL_COMMUNITIES_SUCCESS,
    failureType: hospitalsTypes.GET_ALL_COMMUNITIES_FAILURE,
    method: 'GET',
    endpoint: endpoints.GET_ALL_COMMUNITIES,
  }),
}
